// TODO: Using HipChat icons as the standard icon set is missing large
// versions of `chevron-up` and `chevron-down`, despite already including
// `chevron-left-large` and `chevron-right-large`...
import React, { memo } from 'react';

import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';

/**
 * __Expand icon__
 *
 * An icon used to display the expanded state in an `<ExpandableCell>`.
 */
export const ExpandIcon: React.MemoExoticComponent<({ isExpanded }: { isExpanded: boolean; }) => React.JSX.Element> = memo(({ isExpanded }: { isExpanded: boolean }): React.JSX.Element => {
	switch (isExpanded) {
		case false:
			return <ChevronRightIcon spacing="compact" label="" color="currentColor" size="small" />;
		case true:
			return <ChevronDownIcon spacing="compact" label="" color="currentColor" size="small" />;
	}
});
